import type { TelemetryPort } from '@core/domain/ports/driven/TelemetryPort.ts';
import { ConsoleTelemetryAdapter } from '@src/modules/platform/telemetry/infrastructure/ConsoleTelemetryAdapter.ts';
import { OtelTelemetryAdapter } from '@src/modules/platform/telemetry/infrastructure/OtelTelemetryAdapter.ts';
import { parseOtlpHeaders } from '@src/modules/platform/telemetry/infrastructure/otlpHttpExport.ts';

const noopTrace = { end: () => {}, fail: () => {} };

const noopTelemetry: TelemetryPort = {
  logInfo: () => {},
  logError: () => {},
  trackEvent: () => {},
  setUserContext: () => {},
  logHttpRequest: () => {},
  logHttpResponse: () => {},
  startTrace: () => noopTrace,
};

/** Composition root: read `TELEMETRY_PROVIDER` from the bundle (Vite) / Vitest. Default: `noop`. */
export function createTelemetry(): TelemetryPort {
  const r = (import.meta.env.TELEMETRY_PROVIDER as string | undefined)?.trim().toLowerCase() || 'noop';
  if (r === 'console') return new ConsoleTelemetryAdapter();
  if (r === 'otel') {
    return new OtelTelemetryAdapter({
      endpoint: import.meta.env.OTEL_EXPORTER_OTLP_ENDPOINT ?? '',
      serviceName: import.meta.env.OTEL_SERVICE_NAME || import.meta.env.ADMIN_APP_TITLE || 'esan-paquetes',
      headers: parseOtlpHeaders(import.meta.env.OTEL_EXPORTER_OTLP_HEADERS),
    });
  }
  return noopTelemetry;
}
